<template>
    <div v-if="registration.id">
        <card-header title="Registration" icon="fa-user"></card-header>

        <card-toolbar v-if="!registration.is_deleted">
            <button @click="$openCard('edit-registration', {confId: props.confId, regId: registration.id}, card)"><i class="far fa-pencil"></i>Edit</button>
            <button @click="$openCard('refund-registration', {confId: props.confId, regId: registration.id}, card)"><i class="far fa-times"></i>Refund/Delete</button>
            <button @click="$openCard('user', {userId: registration.users.id}, card)" v-if="currentUser.isSuper"><i class="far fa-user"></i>User Details</button>
        </card-toolbar>

        <card-body>
            <card-list>

                <container-list-item padded v-if="registration.is_deleted" style="background: #a60707;" class="has-text-white has-text-weight-bold"><i class="fas fa-info-circle mr-2 fa-fw ml-2"></i>This registration has been deleted.</container-list-item>

                <subheader-list-item title="Registration" icon="fa-id-card"/>
            </card-list>

            <data-row title="Full Name">
                <span class="clickable" @click="$copyText(registration.users.first_name + ' ' + registration.users.last_name)">{{registration.users.first_name}} {{registration.users.last_name}}</span>
            </data-row>
            <data-row title="Type">{{registration.conf_reg_types.title}}</data-row>
            <data-row title="Date">{{registration.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
            <data-row title="Confirmation">{{registration.code}}</data-row>
            <data-row title="Payment">
                <span v-if="registration.payment_type === 'cc'">{{registration.total_paid | currency}} by Credit Card</span>
                <span v-if="registration.payment_type === 'po'">{{registration.total_paid | currency}} by Purchase Order</span>

                <div class="mt-4" v-if="registration.is_po_pending">
                    <div>
                        <i class="fas fa-exclamation-triangle mr-2 has-text-warning"></i>This registration is <span class="has-text-warning has-text-weight-bold">pending</span> and therefore not completed. The registrant opted to have the registration payed by purchase order (P.O.). Once the purchase order process has been fulfilled you can safely activate the registration. They will receive an e-mail notification that their registration is confirmed once activated.
                    </div>
                    <b-button type="is-danger" size="is-small" class="mt-4 mb-5" @click="activate"><i class="fas fa-check mr-2"></i> Activate Registration</b-button>
                </div>
            </data-row>

            <card-list>
                <subheader-list-item title="Personal" icon="fa-id-card"/>
            </card-list>

            <data-row title="E-Mail Address"><span class="clickable" @click="$copyText(registration.users.email)">{{registration.users.email}}</span></data-row>
            <data-row title="Alt E-Mail Address"><span class="clickable" @click="$copyText(registration.users.email_2)">{{registration.users.email_2}}</span></data-row>
            <data-row title="Home Phone"><span class="clickable" @click="$copyText(registration.users.phone)">{{registration.users.phone | tel}}</span></data-row>
            <data-row title="Work Phone"><span class="clickable" @click="$copyText(registration.users.phone_2)">{{registration.users.phone_2 | tel}}</span></data-row>
            <data-row title="Address">
                <div class="clickable" @click="$copyText(registration.users.address + ((registration.users.address_2)?', '+registration.users.address_2:', ') + registration.users.city + ', ' + registration.users.state + ' ' + registration.users.zip)">
                    <div>{{registration.users.address}}</div>
                    <div v-if="registration.users.address_2">{{registration.users.address_2}}</div>
                    <div>{{registration.users.city}}, {{registration.users.state}} &nbsp;{{registration.users.zip}}</div>
                </div>
            </data-row>

            <card-list>
                <subheader-list-item title="Educator" icon="fa-chalkboard-teacher"/>
            </card-list>

            <data-row title="Grade Level">{{registration.users.grade_level}}</data-row>
            <data-row title="Subject">{{registration.users.subject_area}}</data-row>
            <data-row title="School">{{registration.users.school}}</data-row>
            <data-row title="District">{{registration.users.district}}</data-row>

            <!--            <card-list>-->
            <!--                <subheader-list-item title="Payment" icon="fa-credit-card"/>-->
            <!--            </card-list>-->

            <!--            <data-row title="On File"></data-row>-->

<!--            <card-list>-->
<!--                <subheader-list-item title="Registration Questions" icon="fa-question-circle"/>-->
<!--            </card-list>-->

            <card-list>
                <subheader-list-item title="Certification Applications" icon="fa-file-certificate"/>

                <navigation-list-item
                    v-for="app in registration.reg_applications"
                    :title="app.conf_applications.applications.title"
                    icon="fa-file-certificate"
                    @click="$openCard('application-applicant', {applicantId: app.id, applicationId: app.conf_applications.applications.id, applicantType: 'conf'}, card)"
                    :active="(child && child.definition.component === 'application-applicant' && app.id === parseInt(child.props.applicantId))"
                />

            </card-list>



        </card-body>
    </div>
</template>
<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import ConferenceTile from "../../../components/tiles/ConferenceTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import {mapGetters} from "vuex";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {ApplicantTile, ConferenceTile, ContainerListItem, SeparatorListItem, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                registration: {}
            };
        },
        methods: {
            loadRegistration: function(force) {
                this.$emit('loading', true);
                http.get('registrations/' + this.props.regId, {force}).then(response => {
                    this.registration = response.data;
                    this.$emit('loading', false);
                });
            },
            activate: function() {
                http.post('conferences/' + this.props.confId + '/registrations/' + this.props.regId + '/activate').then(response => {
                    this.loadRegistration(true);
                    this.$reloadCard('registrations', {confId: this.props.confId});
                    this.$reloadCard('conference', {confId: this.props.confId});
                });
            },
            reload: function() {
                this.loadRegistration(true);
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        watch: {
            'props.regId': function() {
                this.loadRegistration(true);
            }
        },
        mounted: function() {
            this.loadRegistration();
        }
    };
</script>

